const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="footer mt-auto py-3 bg-light">
            <div className="container">
                <span className="text-muted">Copyright &#169; Health First Health Plans {year}</span>
            </div>
        </footer>
    )
}

export default Footer
